/* eslint-disable camelcase */
import { Component, OnDestroy, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';
import { Element, AutomatedTestArea } from '../models/ast-element.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { MenuItem } from '../../../shared-components/controls/menus/menu-item.model';
import { ElementAddEditModalComponent } from './element-add-edit-modal.component';



@AutoUnsubscribe()
@Component({
    selector: 'ElementListModalComponent',
    templateUrl: './element-list.component.html',
    styleUrls: ['./element-list.component.css']
})

export class ElementListModalComponent implements OnDestroy, OnInit {

    PageTitle: string;
    Message: string;

    dataSource: TylerMatTableDataSource;

    elementAddEditDialogRef: MatDialogRef<ElementAddEditModalComponent>;

    @ViewChild(MatPaginator) paginator: MatPaginator;

    topActionMenuItems: string[] = ['Edit'];


    allElements: Element[] = [];
    allAreas: AutomatedTestArea[] = [];
    distinctTestAreas: AutomatedTestArea[] = [];
    distinctElements: Element[] = [];
    selectedArea: AutomatedTestArea[] = []; // This is used to set the Area ID
    selection: string;

    elementProperties: string[] = [];

    elementArea: string;
    elementSubArea: string;
    elementControlName: string;
    newModuleName: string;
    newPortalName: string;
    elementId: number;
    areaId: number;

    elementName: string;
    @ViewChild('NewElementName') name: ElementRef;

    elementXPath: string;
    @ViewChild('NewElementXPath') xpath: ElementRef;

    @ViewChild('NewPortalName') portal: ElementRef;

    newElement: Element = {
        Element_ID: 0,
        ElementArea_ID: 0,
        ElementName: '',
        ElementAreaName: '',
        ElementSubAreaName: '',
        ElementSubAreas: [],
        ControlName: '',
        XPath: '',
        ParameterName: '',
        ParameterValue: '',
        Action: '',
        Actions: []
    };

     // ----------Angular Material------------------------------------
     angularMatData = new TylerMatTableDataSource();
     @ViewChild(MatSort, { static: true }) sort: MatSort;
     columnsToDisplay: string[] = []
     subscriptions: Subscription[] = [];

    constructor(
        private reportService: ReportingService,
        private dialogRef: MatDialogRef<ElementListModalComponent>,
        _elementAddEditDialogRef: MatDialogRef<ElementAddEditModalComponent>,
        private _elementAddEditDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) {
        this.PageTitle = data.PageTitle;
        this.Message = data.Message;
    }

    ngOnInit() {
        this.columnsToDisplay = ['ElementAreaName', 'ElementSubAreaName', 'ElementName', 'XPath', 'ControlType', 'Action'];
        this.getAllElements();
    }

    ngOnDestroy() { }

    cancelClick() {
        this.dialogRef.close(false);
    }

    setElementArea(area: AutomatedTestArea) {
        this.elementArea = area.AreaName;
    }

    setElementAreaForUpdate(area: string) {
        this.elementArea = area;
    }

    setElementSubArea(subarea: string) {
        this.elementSubArea = subarea;
    }

    setElementName() {
        this.elementName = this.name.nativeElement.value;
    }

    setElementNameForUpdate(elementName: string) {
        this.elementName = elementName;
    }

    setElementXPath() {
        this.elementXPath = this.xpath.nativeElement.value;
    }

    setElementXPathForUpdate(xpath: string) {
        this.elementXPath = xpath;
    }

    setElementControl(controlname: string) {
        this.elementControlName = controlname;
    }

    setElementId(id: number) {
        this.elementId = id;
    }

    // This method is used for getting all of the elements for the Element List page.
    getAllElements() {
        this.reportService.getAutomatedTestElements(0).subscribe(elem => {
            // Get and sort all elements; filter out tests.
            this.allElements = elem;
            this.allElements.sort((a, b) => a.ElementAreaName > b.ElementAreaName ? 1: -1);
            this.allElements = this.allElements.filter(e => e.ControlName !== 'Test');

            // Populate table and paginate. Filtering will need to be implemented.
            this.dataSource = new TylerMatTableDataSource(this.allElements);
            this.dataSource.paginator = this.paginator;
        });
    }

    // This will display the dialog for adding new elements
    showElementAdd() {

        this.elementAddEditDialogRef = this._elementAddEditDialog.open(ElementAddEditModalComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            data: {
              PageTitle: 'Create New Element',
              Message: 'Create a new element.',
            }
          });

    }

    // This will display the dialog for updating existing elements upon clicking the 'Edit' Action button
    showElementEdit() {

        this.elementAddEditDialogRef = this._elementAddEditDialog.open(ElementAddEditModalComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            data: {
              PageTitle: 'Edit Element',
              Message: 'Edit an existing element.',
              elementArea: this.elementArea,
              elementSubArea: this.elementSubArea,
              elementName: this.elementName,
              elementXPath: this.elementXPath,
              elementControlName: this.elementControlName,
              elementId: this.elementId,
            }
          });

          this.elementAddEditDialogRef.afterClosed().subscribe( res => {
               this.ngOnInit();
          });

    }

    // Table-related methods --------------------------------

    getAriaRow(row: any): string {
        return '';
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }

    actionMenuClick(menuItem: MenuItem) {
        // const data: ElementsAndAreasModalComponent = menuItem.data;
        console.log(this.elementId);

        // this.elementProperties = [this.elementArea, this.elementSubArea, this.elementName, this.elementXPath, this.elementControlName];

        switch (menuItem.itemName) {
            case 'Edit':
                this.showElementEdit();
                break;
        }
    }


}
